import React, { useEffect, useState } from 'react';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import { useLocation, useNavigate } from 'react-router-dom';
import classes from './style.module.scss';
import { TextField } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Button from "../../../../component/Button";
import { Icons } from '../../../../assets';
import ReportUpload from './reportUpload';
import SuccessModal from '../../../../modalComponents/SuccessModal';
import Exported from '../../../../service/endpoints';
import { Toast } from '../../../../service/toast';
import request from '../../../../service';
import moment from 'moment';
import DateSelector from '../../../../component/DateSelector';
import { FormProvider, useForm } from 'react-hook-form';
import axios from 'axios';
import config from '../../../../service/env';
import { singleUpload } from '../../../../helpers';

const GenerateReport = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const pathName = location?.search?.split('?id=')
    const params = pathName[1]
    const moment = require('moment')
    const redirectBack = () => {
        navigate('/admin/retailer-tod');
    };


    const [showDownloadReport, setShowDownloadReport] = useState(false);
    const [fileName, setFileName] = useState('');
    const [uploadedFiles, setUploadedFiles] = useState(null);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [year, setYear] = useState(2024);
    const [reportName, setReportName] = useState("")
    const [downloadUrl, setDownloadUrl] = useState("")
    const [showErr, setShowErr] = useState(false)
    const [errMess, setErrMess] = useState("")
    const [id, setId] = useState()
    const [uploadUrl, setUploadUrl] = useState('')

    const formMethods = useForm({
        mode: "onSubmit",
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        trigger,
        setValue,
        watch
    } = formMethods

    const { apiUrl } = config

    const selectedStartDate = watch("startDate")


    const onSubmit = (data) => {
        let url = Exported.Endpoints.downloadReport;

        let paramsObj = {
            startDate: data.startDate,
            endDate: data.endDate,
            reportName: "Retailer TOD"
        }

        request({
            url: url,
            method: Exported.APIMethods.POST,
            data: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                const response = res?.data?.data
                console.log(res)
                setReportName(response?.reportName)
                setId(response?.id)
                setDownloadUrl(response?.downloadedReportUrl)
                setYear(response?.updatedAt)
                setShowDownloadReport(true)
                setShowErr(false)
            }
        }).catch((err) => {
            setShowErr(true)
        });
    }

    const getSpecificRetailer = async () => {
        let url = `${Exported.Endpoints.getOneRetailer}/${params}`

        await request({
            url: url,
            method: Exported.APIMethods.GET,
        }).then((res) => {
            if (res?.data?.status) {
                console.log(res)
                const response = res?.data?.data
                setShowDownloadReport(true)
                setReportName(response?.reportName)
                setId(response?.id)
                setDownloadUrl(response?.downloadedReportUrl)
                setYear(response?.updatedAt)
            }
        }).catch((err) => {
            Toast({
                type: "error",
                message: "Unable to process the request!..",
            });
        });
    }

    const uploadRetailer = async () => {
        let url = `${Exported.Endpoints.uploadReport}/${id}`
        let paramsObj = {
            uploadedReportUrl: uploadUrl
        }

        await request({
            url: url,
            method: Exported.APIMethods.PUT,
            data: { ...paramsObj },
        }).then((res) => {
            console.log(res)
            if (res?.data?.status) {
                setShowSuccessModal(true);
            }
        }).catch((err) => {
            console.log(err)
            setErrMess(err?.response?.data?.message || "An error occurred during upload.")
        })
    }

    const handleSuccessModalClose = () => {
        setShowSuccessModal(false);
        redirectBack()
    };

    useEffect(() => {
        if (params) {
            getSpecificRetailer()
        }
    }, [])

    useEffect(() => {
        if (uploadedFiles && uploadedFiles.length > 0) {
            setErrMess("");
            singleUpload(uploadedFiles).then((res) => {
                setUploadUrl(res?.url)
            }).catch((err) => {
                Toast({
                    type: 'error',
                    message: 'Unable to upload the file!..'
                })
            })
        }
    }, [uploadedFiles])

    return (
        <>
            <div className={`${classes.createAdminWrapper}`}>
                <div className="layout-title flex items-center">
                    <div className="mr-2 flex items-center cursor-pointer" onClick={redirectBack}>
                        <ArrowBackIosOutlinedIcon />
                    </div>
                    <div>Generate Report</div>
                </div>
                <div className="my-8">
                    {<div className={`${classes.createReport} pb-6`}>
                        <p className={`${classes.reportHeader} mx-6 py-4`}>Select Report Date</p>
                        <div className="flex space-x-4 mx-6 pb-4 gap-4">
                            <FormProvider {...formMethods}>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <DateSelector
                                        className={`w-[30%] !mr-4`}
                                        name="startDate"
                                        control={formMethods.control}
                                        label={"Start Date"}
                                        error={errors.startDate}
                                        messages={{
                                            required: "Start Date is required",
                                            validate: "Date must be in YYYY-MM-DD format",
                                        }}
                                        disabled={params ? true : false}
                                    />

                                    <DateSelector
                                        className={`w-[30%] !mr-4`}
                                        name="endDate"
                                        control={formMethods.control}
                                        label={"End Date"}
                                        error={errors.endDate}
                                        messages={{
                                            required: "End Date is required",
                                            validate: "Date must be in YYYY-MM-DD format",
                                        }}
                                        disabled={params ? true : false}
                                        minDate={selectedStartDate ? moment(selectedStartDate).format('YYYY-MM-DD') : null}
                                    />
                                    <Button
                                        text={"Search"}
                                        className={"!px-4"}
                                        smallBtn
                                        style={{ height: "56px", padding: "4px 30px", width: "170px" }}
                                        disabled={params ? true : false}
                                        onClick={(e) => params ?  e.preventDefault() : null}
                                    />
                                </form>
                            </FormProvider>
                        </div>
                        {showDownloadReport && <div>
                            <div className='mx-6 py-3 flex gap-6 text-[#01CB46]'>
                                <img src={Icons.tickIcon} />
                                <p>Your report is ready for the mentioned date !</p></div>
                            <div className='mx-6 py-3  flex bg-[#58BCBD] w-[500px] items-center  rounded-[10px]'>
                                <img src={Icons.fileText} className='pl-4 mr-7' />
                                <p className={`${classes.retailerDate} pr-4 mr-10 text-wrap`} >{`${reportName} ${moment(year).format("MM-YYYY")}` || "Retailer TOD 2024"}</p>
                                {/* <Button
                                    text={"Download"}
                                    className={"!px-4"}
                                    smallBtn
                                    style={{ height: "48px", width: "150px" }}
                                    onClick={() => downloadReport()}
                                /> */}
                                <a href={downloadUrl} className={`${classes.downloadLink} flex justify-center items-center`} download>Download</a>
                            </div>

                        </div>}
                        {
                            showErr && <div className='mx-6 py-2 flex gap-6 text-red-500'>No Data Found</div>
                        }
                    </div>}
                    <div className={`${classes.createReport} my-6 px-4 py-2`}>
                        <ReportUpload placeholder={"Upload File (Max: 20 MB)"} fileName={fileName} setFileName={setFileName} files={uploadedFiles} setFiles={setUploadedFiles} isFileUploading={downloadUrl ? false : true} />
                        {
                            errMess && <div className='mx-2 py-2 flex gap-6 text-red-500'>{errMess}</div>
                        }
                    </div>
                    {uploadedFiles && <div className='flex justify-end mb-6'>
                        <Button text="Submit" style={{ width: "170px", height: "40px", fontSize: "16px" }} onClick={() => uploadRetailer()} />
                    </div>}
                </div>
            </div>
            {showSuccessModal ? (
                <SuccessModal
                    isOpen={showSuccessModal}
                    closePopUp={handleSuccessModalClose}
                    successText={"Submitted"}
                    boxAlign="center"
                    modalText={"Retailer TOD has been submitted successfully in DB Asset"}
                />
            ) : null}
        </>
    );
};

export default GenerateReport;
